export default "__VITE_ASSET__DcyTaFWf__"